export default __webpack_public_path__ + "1ec53fed7e35cb2f38231b37211e435b.png";